export default __webpack_public_path__ + "static/media/ataud.84cfbb13.png";